import React from 'react'

import Icon from '../../Global/Icon'

export default ({menuOpened, handleNavClick}) => (
  <div className="menu-button">
    <button className="button button--outline button--icon" type="button" onClick={() => handleNavClick()}>
      {menuOpened && <Icon className="icon" icon="close" />}
      {!menuOpened && <Icon className="icon" icon="menu" />}
    </button>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Menu/MenuButton/MenuButton.js